import React from "react";
import { useColorMode } from "theme-ui";
import { Button } from "rebass";

const modes = ["light", "dark", "pink"];

const ThemeSwitcher = () => {
  const [colorMode, setColorMode] = useColorMode();
  return (
    <Button sx={{ variant: "buttons.primary", fontSize: [2,2] }}
      onClick={() => {
        const index = modes.indexOf(colorMode);
          const next = modes[(index + 1) % modes.length];
          setColorMode(next);
        }}
      >
        Change colors
    </Button>
  );
};

export default ThemeSwitcher;
